<template>
  <div ref="lavContainer" class="lottie-container"></div>
</template>

<script lang="ts">
import type { Ref } from 'vue';
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['created'],
  async setup(props, { emit }) {
    const lavContainer: Ref<HTMLInputElement> = ref(null);
    watch(props, () => {
      createAnimation();
    });

    const createAnimation = async () => {
      try {
        const { default: jsonData } = await import(`../assets/lottie/${props.name}.json`);
        const lottieAnimation: any = lottie.loadAnimation({
          container: lavContainer.value,
          renderer: 'svg',
          loop: props.loop,
          autoplay: props.autoplay,
          animationData: jsonData,
        });
        emit('created', lottieAnimation);
      } catch (e) {
        console.error(e);
      }
    };
    const lottie = await import('lottie-web/build/player/lottie_light').then(
      module => module.default
    );
    createAnimation();

    return {
      lavContainer,
    };
  },
});
</script>
<style lang="scss" scoped>
.lottie-container {
  overflow: hidden;
  margin: 0 auto;
}
</style>
